export default __webpack_public_path__ + "locales/zh-CN/Ldap.json?hash=b059d649b66130edef9e224ee9598324";